/**
 * شاشة معتمدة في التصميم لكن كودها لسه ما اتكتبش.
 *
 * ⚠️ **السبب الحقيقي لوجود الملف ده**: الجرس كان بيودّي على `NotFound`
 *    برسالة «الصفحة دي مش موجودة» — والشاشة **موجودة** في التصميم. الرسالة
 *    نفسها كانت كذب، والموظف بيدوّر على حاجة موجودة عنده وهو مصدّق إنها مش
 *    موجودة. الشاشة اللي لسه بتتجهّز بتقول كده بصراحة.
 *
 * ⛔ ممنوع تستبدلها بـ`NotFound` — الاتنين مش نفس المعنى:
 *    «لسه بتتجهّز» = موجودة وجاية · «مش موجودة» = الرابط غلط.
 */
import { Shell } from "@/components/Shell";
import { EmptyState } from "@/components/states/ScreenStates";

export function UnderConstruction({
  title,
  /** الشاشات جوّه السيستم بتتلف في الشِل · شاشات المصادقة لأ */
  chrome = "shell",
}: {
  title: string;
  chrome?: "shell" | "bare";
}) {
  const body = (
    <EmptyState title={`شاشة «${title}» لسه بتتجهّز`} hint="هتفتح مع المرحلة الجاية" fill />
  );

  if (chrome === "bare") {
    return (
      <div
        dir="rtl"
        style={{
          minHeight: "100vh",
          background: "var(--bg)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px 24px",
        }}
      >
        <div style={{ width: 480, maxWidth: "100%", display: "flex" }}>{body}</div>
      </div>
    );
  }

  return <Shell title={title}>{body}</Shell>;
}
